import  { jwtServerInstance }  from '../index'
import {getTokenUser} from "@/lib/utils";
import qs from	'qs'

export const getAllCustoMoneySetting = () => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/all',
        method:'post'
    })
}
//列表查询接口
export const getCustoMoneySetting = (queryFrom, pagination) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/query',
        method:'post',
        data:qs.stringify({
            cmsettingId:queryFrom.cmsettingId,
            b2cTaskTypeId:queryFrom.b2cTaskTypeId,
            startPrice:queryFrom.startPrice,
            endPrice: queryFrom.endPrice,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


//列表查询接口
export const getSalemanWebMoneySetting = (queryFrom, pagination) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/salemanquery',
        method:'post',
        data:qs.stringify({
            salemanId:queryFrom.salemanId,
            b2cTaskTypeId:queryFrom.b2cTaskTypeId,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


//列表查询接口
export const querySalemanWebConfigSetting = (queryFrom) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/salemancfgquery',
        method:'post',
        data:qs.stringify({
            salemanId:queryFrom.salemanId
        })
    })
}

//新增一条sys_role数据记录
export const addSalemanWebConfigSetting = (roleForm) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/addupdatesalemanconfig',
        method:'post',
        data:roleForm
    })
}

//新增一条sys_role数据记录
export const addSalemanWebMoneySetting = (roleForm) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/addsalemanmoney',
        method:'post',
        data:roleForm
    })
}


//更新sys_role的一条数据记录
export const updateSalemanWebMoneySetting = (roleForm) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/updatesalemanmoney',
        method:'post',
        data:roleForm
    })
}

//更新sys_role的一条数据记录
export const updateCustoMoneySetting = (roleForm) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/update',
        method:'post',
        data:roleForm
    })
}

//新增一条sys_role数据记录
export const addCustoMoneySetting = (roleForm) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/add',
        method:'post',
        data:roleForm
    })
}

//删除一条sys_role数据记录
export const deleteCustoMoneySetting = (id) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/delete',
        method:'post',
        data:qs.stringify({
            id:id
        })
    })
}

//删除一条sys_role数据记录
export const queryCustoMoneySettingModel = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/salemanquerymodel',
        method:'post',
        data:qs.stringify({
            salemanId: queryForm.salemanId,
            b2cTaskTypeId:queryForm.b2cTaskTypeId
        })
    })
}


//删除一条sys_role数据记录
export const deleteSalemanWebMoneySetting = (id) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/deleteslamenmoney',
        method:'post',
        data:qs.stringify({
            id:id
        })
    })
}

